import { render, staticRenderFns } from "./ListBrokersFiltered.vue?vue&type=template&id=db02b4f0"
import script from "./ListBrokersFiltered.vue?vue&type=script&lang=js"
export * from "./ListBrokersFiltered.vue?vue&type=script&lang=js"
import style0 from "./ListBrokersFiltered.vue?vue&type=style&index=0&id=db02b4f0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItemSection,QItemLabel,QTooltip,QSeparator});
